import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import selectModal from 'store/modals/selectors';
import { MODAL_WORKSPACE_UPDATE_NAME } from 'store/modals/modals';
import { ModalContent, Wrapper, EditorWrapper } from 'Screens/Contextualization/Host/components/HostVulnerabilities/VulnsTable/BulkUpdateModal/styled';
import BulkTitle from 'Screens/Contextualization/Manage/components/ManageTable/components/BulkUpdateModal/components/BulkTitle';
import DebouncedInput from 'Common/Components/v2/DebouncedInput';
import { setUpdateField, setUpdateValue } from 'Screens/Contextualization/Workspaces/actions/Actions';
import { selectWsDetail } from 'store/Workspace/selectors';
import Buttons from './Buttons';
import { get } from 'lodash';

/** For now, only the name field is being updated. The current implementation (with the appropriate changes) would allow editing any field.  */

const UpdateModal = () => {
  const dispatch = useDispatch();

  const showModal = useSelector((state) => selectModal(state, MODAL_WORKSPACE_UPDATE_NAME));
  const onChange = (value) => dispatch(setUpdateValue(value));
  const workspaceDetail = useSelector(selectWsDetail);
  const currentName = get(workspaceDetail, 'name', '');

  useEffect(() => () => {
    dispatch(setUpdateField(''));
    dispatch(setUpdateValue(''));
  }, [dispatch]);

  if (!showModal) return null;
  return (
    <Wrapper>
      <ModalContent>
        <BulkTitle />
        <EditorWrapper>
          <DebouncedInput
            value={ currentName }
            onChange={ onChange }
            name="name"
            title="name"
            focusOnMount
          />
        </EditorWrapper>
        <Buttons />
      </ModalContent>
    </Wrapper>
  );
};

export default UpdateModal;
